/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Privacy_P1Inputs */

const es_tyc_privacy_p1 = /** @type {(inputs: Tyc_Privacy_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata procesa datos personales unicamente segun lo necesario para proporcionar el Servicio y conforme a su Politica de Privacidad. Las Fuentes Conectadas pueden tener sus propias practicas de privacidad; se le recomienda revisarlas.`)
};

const en_tyc_privacy_p1 = /** @type {(inputs: Tyc_Privacy_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata processes personal data only as necessary to provide the Service and in accordance with its Privacy Policy. Connected Sources may have their own privacy practices; you are encouraged to review them.`)
};

/**
* | output |
* | --- |
* | "Nexata processes personal data only as necessary to provide the Service and in accordance with its Privacy Policy. Connected Sources may have their own priva..." |
*
* @param {Tyc_Privacy_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_privacy_p1 = /** @type {((inputs?: Tyc_Privacy_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Privacy_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_privacy_p1(inputs)
	return en_tyc_privacy_p1(inputs)
});
export { tyc_privacy_p1 as "tyc.privacy.p1" }